module.exports = "/_next/static/images/Unify-dcc6905605cfde3b9c33f6995cf9a101.webp";